// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"4587dc4b","54":"81437318","65":"e574c9ad","98":"18751ed4","253":"ec0d0e11","301":"66af88f0","358":"be397315","431":"401aaa31","470":"aa52f024","489":"c887c0f0","672":"565ce8c9","683":"d6a38a4d","689":"ebc4392a","864":"6c1758e5"}[chunkId] + ".chunk.js";
};